<template lang="pug" src="./block-tab-section.pug"></template>

<script>
import Title from 'components/block/block-title/block-title'

export default {
  props: ['props'],
  data () {
    return {
      active: 0
    }
  },
  methods: {
    setIndex (i) {
      this.active = i
    },
    setTechIndex (i) {
      this.$store.dispatch('VIEW_BODY', i)
    }
  },
  components: {
    Title
  }
}
</script>



// WEBPACK FOOTER //
// block-tab-section.vue?690875d5